import { render, staticRenderFns } from "./MultiTextQuestionForm.vue?vue&type=template&id=1a61f85e"
import script from "./MultiTextQuestionForm.vue?vue&type=script&lang=ts"
export * from "./MultiTextQuestionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports